module.exports = __webpack_public_path__ + "img/activity-2.c7419bab.jpg";